import { RequestService } from "../../../../../common/services/RequestService";
import { ARCHIEVE_ORDER } from "../constants";

export const archieveOrderRequest = async (payload, profileId) => {
  const response = await RequestService.put(
    ARCHIEVE_ORDER.replace("{order_id}", payload.id).replace(
      "{profile_id}",
      profileId
    ),
    {
      order_status_key: payload.status
    }
  );
  return response;
};
